import React, { useCallback, useState } from 'react';
import { ToString } from '../../../lib/utils';
import Localization from '../../../config/localization';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import DownloadSvg from '../../../components/Svg/download';
import { REPORT_TYPE } from '../../../constants/report-type';
import { noop } from 'lodash';
import { UTILITY_TYPES } from '../../../constants/utilityType';
import { FILE_FORMATS } from '../../../constants/file';

function Centralizator(props: any) {
  const { disabled, isAdmin, download } = props;

  const [mouseIn, setMouseIn] = useState(false);

  const onMouseEnter = useCallback(() => setMouseIn(true), [setMouseIn]);
  const onMouseLeave = useCallback(() => setMouseIn(false), [setMouseIn]);

  const doDownload = useCallback(({ reportType, reportFormat, utilityType, fileName }) => (event: React.MouseEvent) => {
    if (!disabled) {
      return download(event, { reportType, reportFormat, utilityType, fileName });
    }

    return undefined;
  }, [download, disabled]);


  return (
    <Dropdown
      className={`download-centralizator d-flex c-pointer-no-color ${ToString(disabled && 'disabled')}`}
      nav
      isOpen={mouseIn}
      disabled={isAdmin}
      onClick={doDownload({
        reportType: REPORT_TYPE.NORMAL,
        fileName: Localization.paymentsReportsDownloadReportTypeNormal
      })}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      toggle={noop}
    >
      <DropdownToggle className="eon-centralizator-title" nav>
        <h4 className="eon-title eon-red my-auto">{Localization.paymentsReportsDownloadCentralizator}</h4>
        <DownloadSvg className="my-auto mx-2" />
      </DropdownToggle>

      {isAdmin && !disabled && <DropdownMenu className="eon-dropdown-menu-centralizator">
        <DropdownItem
          className="eon-title eon-darkgrey c-pointer-no-color"
          onClick={doDownload({
            reportType: REPORT_TYPE.NORMAL,
            fileName: Localization.paymentsReportsDownloadReportTypeNormal
          })}>
          {Localization.paymentsReportsDownloadReportTypeNormal}
        </DropdownItem>
        {Object.keys(UTILITY_TYPES).map((utilityTypeKey) => FILE_FORMATS.map((reportFormat) => {
          const utilityType = UTILITY_TYPES[utilityTypeKey];

          const adminFileName = Localization.formatString(Localization.paymentsReportsDownloadReportTypeAdmin, Localization.paymentsReportsDownloadReportType[utilityType]);

          return (<DropdownItem
            key={utilityType + reportFormat}
            className="eon-title eon-darkgrey c-pointer-no-color"
            onClick={doDownload({
              reportType: REPORT_TYPE.ADMIN,
              utilityType,
              reportFormat,
              fileName: adminFileName
            })}>
            {adminFileName} {reportFormat}
          </DropdownItem>);
        }))}
      </DropdownMenu>}

    </Dropdown>

  );
}

export default Centralizator;